<template>
    <div class="preloader-area">
        <div class="preloader-content">
            <div class="spinner">
                <div class="inner">
                    <div class="disc"></div>
                    <div class="disc"></div>
                    <div class="disc"></div>
                </div>
            </div>
            <div class="preloader-text">Benovium</div>
            <div class="preloader-subtext">Development</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Preloader',
}
</script>